import React, { useState } from 'react';
import {
  AutocompleteInput,
  Create,
  Edit,
  ReferenceField,
  ReferenceInput,
  required,
  Show,
  ShowButton,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  useChoicesContext,
} from 'react-admin';
import AutocompleteStudioInput from './components/AutocompleteStudioInput';
import ClipboardField from './components/ClipboardField';
import InfiniteList from './components/InfiniteList';
import { WriteOnlyDatagrid } from './components/WriteOnlyDatagrid';
import { WriteOnlyEditButton } from './components/WriteOnlyEditButton';

export const MboContractMappingList: React.FC = () => (
  <InfiniteList>
    <WriteOnlyDatagrid bulkActionButtons={false}>
      <ClipboardField source="id" sortable={false} />
      <ReferenceField source="studio.id" reference="Studio" label="Studio">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="employeeType" label="Employee Type" sortable={false} />
      <TextField
        source="mboServiceId"
        label="MBO Service ID"
        sortable={false}
      />
      <WriteOnlyEditButton />
      <ShowButton />
    </WriteOnlyDatagrid>
  </InfiniteList>
);

export const MboContractMappingShow: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <ClipboardField source="id" label="ID" fontSize={14} />
      <ReferenceField source="studio.id" reference="Studio" label="Studio">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="mboServiceId" label="MBO Service ID" />
      <TextField source="employeeType" label="Employee Type" />
    </SimpleShowLayout>
  </Show>
);

export const MboContractMappingEdit: React.FC = () => (
  <Edit mutationMode="pessimistic" redirect={false}>
    <SimpleForm>
      <AutocompleteStudioInput source="studio.id" label="Studio" isRequired />
      <TextInput source="mboServiceId" label="MBO Service ID" />
      <TextInput source="employeeType" label="Employee Type" />
    </SimpleForm>
  </Edit>
);

const StudioAutocompleteInput: React.FC<{
  label: string;
  helperText?: string;
  validate: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ label, helperText, validate }) => {
  const { selectedChoices } = useChoicesContext();

  if (selectedChoices?.length && selectedChoices.length > 0) {
    validate(selectedChoices[0].client.usesEligibilityServiceType);
  } else if (selectedChoices?.length) {
    validate(false);
  }

  return (
    <AutocompleteInput
      label={label}
      optionText="name"
      filter="name"
      isRequired
      validate={required('Studio is required')}
      filterToQuery={(name: string) => ({
        name,
      })}
      helperText={helperText}
    />
  );
};

export const MboContractMappingCreate: React.FC = () => {
  const [clientUsesEligibility, setClientUsesEligibility] =
    useState<boolean>(false);
  const eligibilityLabel = clientUsesEligibility
    ? 'The selected studio requires gym members to purchase a service package to get app access.'
    : undefined;
  return (
    <Create>
      <SimpleForm>
        <ReferenceInput
          source="studio.id"
          label="Studio"
          isRequired
          reference="Studio"
        >
          <StudioAutocompleteInput
            label="Studio"
            validate={setClientUsesEligibility}
            helperText={eligibilityLabel}
          />
        </ReferenceInput>
        <TextInput
          source="mboServiceId"
          label="MBO Service ID"
          isRequired
          disabled={clientUsesEligibility}
        />
        <TextInput
          source="employeeType"
          label="Employee Type"
          isRequired
          disabled={clientUsesEligibility}
        />
      </SimpleForm>
    </Create>
  );
};
